import { useEffect, useState } from "react";
import { XIcon } from "@phosphor-icons/react";

const CustomModal = ({ title, children, show, setShow, size }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (show) {
            setIsVisible(true);
            setTimeout(() => setIsAnimating(true), 10);
        } else {
            setIsAnimating(false);
            setTimeout(() => setIsVisible(false), 300);
        }
    }, [show]);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && show) {
                setShow(false);
            }
        };

        if (show) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [show, setShow]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            setShow(false);
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    if (!isVisible) return null;

    return (
        <div 
            className={`c-modal ${isAnimating ? 'c-modal--visible' : ''}`}
            onClick={handleBackdropClick}
        >
            <div className={`c-modal-container ${isAnimating ? 'c-modal-container--visible' : ''}${size ? ` c-modal-container--${size}` : ''}`}>
                <div className="c-modal-header">
                    <h1>{title || "Modal"}</h1>
                    <button 
                        className="modal-close" 
                        onClick={handleClose}
                        aria-label="Fermer"
                    >
                        <XIcon size={20} />
                    </button>
                </div>
                <div className="c-modal-content">{children}</div>
            </div>
        </div>
    );
};

export default CustomModal;
